import { rem, Bold, border } from '@core-web/typography';
import { Box, styled } from '@mui/material';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import { ScrollBarStyle } from '@core-web/ui';
import { ModalSizes } from './enums';

interface IModalSize {
  size?: ModalSizes;
}

const ZIndex = 8000;

export const ModalContainerWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'size',
})<IModalSize>(({ theme: { palette }, size }) => ({
  display: 'flex',
  height: 'auto',
  maxHeight: '60vh',
  width: rem(600),
  ...(size === ModalSizes.MEDIUM && {
    width: rem(900),
  }),
  ...(size === ModalSizes.LARGE && {
    width: rem(1200),
  }),
  border: `1px solid ${palette.colors.black_50}`,
  borderRadius: rem(4),
  backgroundColor: palette.colors.white,
  boxShadow: palette.boxShadow.modalShadow,
  position: 'fixed',
  left: '50%',
  top: `50%`,
  transform: `translate(-50%, -50%)`,
  zIndex: ZIndex,
}));

export const ModalOverlay = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  position: 'fixed',
  left: '0px',
  top: '0px',
  backgroundColor: palette.colors.black,
  opacity: 0.5,
  zIndex: ZIndex,
}));

export const ModalContentWrapper = styled(Box)(({ theme: {} }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
  flexDirection: 'column',
}));

export const ModalContentContainer = styled(Box)(({ theme: {} }) => ({
  display: 'flex',
  height: '100%',
  width: '100%',
}));

export const ModalHeaderWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  width: '100%',
  padding: `${rem(16)} ${rem(24)}`,
  backgroundColor: palette.colors.grey_100,
  borderBottom: border(1, 'solid', palette.colors.black_50),
}));

export const ModalBody = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  width: '100%',
  padding: `${rem(16)} ${rem(24)}`,
  maxHeight: '50vh',
  overflowY: 'auto',
  ...ScrollBarStyle(palette),
}));

export const ModalFooterWrapper = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  width: '100%',
  padding: `${rem(16)} ${rem(24)}`,
  backgroundColor: palette.colors.white,
  borderTop: border(1, 'solid', palette.colors.black_50),
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: rem(8),
}));

export const ModalHeaderContent = styled(Box)(({ theme: {} }) => ({
  display: 'flex',
  width: '100%',
  position: 'relative',
}));

export const ModalBackWrapper = styled(Box)(({ theme: {} }) => ({
  display: 'flex',
  position: 'absolute',
  height: '100%',
  left: 0,
  top: 0,
  gap: rem(8),
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer',
}));

export const ModalBackText = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  color: palette.colors.blue_700,
  fontSize: rem(14),
  fontWeight: Bold._500,
  lineHeight: rem(20),
}));

export const ModalActionButton = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  color: palette.colors.blue_700,
  fontSize: rem(14),
  fontWeight: Bold._500,
  lineHeight: rem(20),
  cursor: 'pointer',
}));

export const ModalTitle = styled(Box)(({ theme: { palette } }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: palette.colors.grey_900,
  fontSize: rem(16),
  fontWeight: Bold._500,
  flex: 1,

  '&.alignCenter': {
    justifyContent: 'center',
  },
}));

export const ModalBackIcon = styled(ArrowBackIosNewOutlinedIcon)(({ theme: { palette } }) => ({
  display: 'flex',
  color: palette.colors.blue_700,
  height: rem(14),
  width: rem(14),
  fontSize: rem(10),
}));

export const ModalHeaderButton = styled(Box)(({ theme: {} }) => ({
  display: 'flex',
  width: 'max-content',
}));
